import { MissingReplacementsError, replace } from '@change-corgi/core/i18n';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

import { useReplacements } from './hooks/useReplacements';

export function useWhatsappShareMessage(): string | undefined {
	const {
		data: {
			whatsappHeadlineExperiment: { variation, variants },
		},
	} = usePsfPromoteOrSharePageData();
	const {
		data: { replacements },
	} = useReplacements();

	const {
		errorReporter: { report },
	} = useUtilityContext();

	if (variation === 'control' || variation === 'fake_control') {
		return undefined;
	}

	const variationData = variants[variation as keyof typeof variants];

	if (!variationData?.message) return undefined;

	try {
		return replace(variationData.message, replacements);
	} catch (e) {
		if (e instanceof MissingReplacementsError) {
			void report({
				error: e,
				params: { page: 'psf/share', variant: variation },
			});
			return e.finalTranslation;
		}
		return undefined;
	}
}
